import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LockedAccountGuardService } from '@tango/app/core/services';
import { LockedPageComponent } from './locked-page.component';

const routes: Routes = [
  {
    path: 'locked',
    component: LockedPageComponent,
    canActivate: [LockedAccountGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LockedPageRoutingModule {}
